import { render, staticRenderFns } from "./TabXMLDataPreview.view.vue?vue&type=template&id=b0771c7a&"
import script from "./TabXMLDataPreview.view.vue?vue&type=script&lang=js&"
export * from "./TabXMLDataPreview.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0771c7a')) {
      api.createRecord('b0771c7a', component.options)
    } else {
      api.reload('b0771c7a', component.options)
    }
    module.hot.accept("./TabXMLDataPreview.view.vue?vue&type=template&id=b0771c7a&", function () {
      api.rerender('b0771c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/purchases/save/TabXMLDataPreview.view.vue"
export default component.exports